// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  GetCostTimeSeriesParams,
  getCostTimeSeries,
} from '@/costs/api/get-cost-time-series';
import { CostTimeSeries } from '@/costs/api/types';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

/**
 * Hook for fetching cost time series data
 */
export const useCostTimeSeries = (
  params: GetCostTimeSeriesParams = {},
  options?: {
    enabled?: boolean;
  }
): UseQueryResult<CostTimeSeries> => {
  return useQuery({
    queryKey: ['costs', 'time-series', params],
    queryFn: () => getCostTimeSeries(params),
    enabled: options?.enabled,
  });
};
